module.exports = __webpack_public_path__ + "static/media/mandolin.6bc614b5.svg";